module.exports = __webpack_public_path__ + "img/no-urls-activity.d5ccde8c.webp";